import { Popup } from "react-leaflet";
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Box,
} from "@mui/material";
import { capitalizeFirst } from "datalign-module-template/components/utils";
import { UUID } from "datalign-module-template/models/uuid";
import React, { useMemo } from "react";
import DatalignChip from "datalign-module-template/components/datalign-chip";
import { useEasierTheme } from "datalign-themes";

const PopupInfo = ({
  info,
}: {
  info: {
    guid: UUID;
    name: string;
    description: string;
    extra: { [x: string]: any };
    tags: string[];
  };
}) => {
  const theme = useEasierTheme();
  const extraDisplay = useMemo(() => {
    try {
      return info.extra && Object.keys(info.extra).length > 0 ? (
        <TableContainer sx={{ p: 1 }}>
          <Table>
            <TableBody>
              {Object.keys(info.extra).map((key) =>
                key && info.extra[key] ? (
                  <TableRow key={`info.extra-${info.guid}-${key}`}>
                    <TableCell>{key}</TableCell>
                    <TableCell>{info.extra[key]}</TableCell>
                  </TableRow>
                ) : (
                  <></>
                ),
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <></>
      );
    } catch (error) {
      console.warn("Error on info.extra popup fields");
      return <></>;
    }
  }, [info.extra]);
  return (
    <Popup minWidth={200}>
      <Typography variant="h5">{capitalizeFirst(info.name)}</Typography>
      {info.description ? (
        <Typography>Description: {info.description}</Typography>
      ) : (
        <></>
      )}
      {extraDisplay}
      <Box sx={{ m: 1 }}>
        {info.tags && info.tags.length > 0 ? (
          info.tags.map((tag) => (
            <DatalignChip
              filled={true}
              key={`tag-${tag}-${info.guid}`}
              chipColour={theme?.Colour.Primary()}
              textColour={theme?.Colour.OnPrimary()}
              content={
                <Typography
                  style={{
                    color: "inherit",
                  }}
                >
                  {tag}
                </Typography>
              }
            />
          ))
        ) : (
          <></>
        )}
      </Box>
    </Popup>
  );
};

export default PopupInfo;
